export const API_URL = "https://apimail.heimdallrwa.com/api/v1/mail";

export const CLAIM_TYPE = "CELSIUS"
export const CLAIM_TYPE_FTX = "FTX"

export const TOKEN_SYMBOL = 'CCT'
export const CALENDY_LINK_URL =process.env.REACT_APP_CALENDY_LINK_URL || ''